// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import { RadioGroup } from 'components/Form'
import { useDispatch } from 'react-redux'
import AntennaCode from './AntennaCode'
import AntennaManufacturer from './AntennaManufacturer'
import handleAntennaFieldToggle from './helpers/handleAntennaFieldToggle'

const options = [{
  label: 'Code',
  value: 'antennaCode',
}, {
  label: 'Manufacturer',
  value: 'antennaCompanyId',
}]

const AntennaField = props => {
  const {
    idRoot,
    input: { value },
    sourceForm,
  } = props

  const dispatch = useDispatch()

  const handleRadioFieldUpdate = event => dispatch(handleAntennaFieldToggle(event, sourceForm))

  if (value !== 'antennaCode' && value !== 'antennaCompanyId') {
    throw new Error(`Error! Value was expected to be 'antennaCode' or 'antennaCompanyId' but was ${value}`)
  }

  return (
    <>
      <div className={'display-flex'}>
        <span>{'Antenna'}</span>
        <RadioGroup
          {...props}
          className={'flat-radios mini-flat-radios'}
          idRoot={`${idRoot}-type`}
          onChangeCustom={handleRadioFieldUpdate}
          options={options} />
      </div>
      {
        value === 'antennaCode'
          ? (
            <AntennaCode
              idRoot={`${idRoot}-code`}
              sourceForm={sourceForm} />
          ) : (
            <AntennaManufacturer
              idRoot={`${idRoot}-manufacturer`} />
          )
      }
    </>
  )
}

AntennaField.propTypes = {
  idRoot: string.isRequired,
  input: object.isRequired,
  sourceForm: string.isRequired,
}
export default AntennaField